import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { CommonLoaderComponent } from 'src/app/shared/components/common-loader/common-loader.component';
import { environment } from 'src/environments/environment';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-descarte-relato',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent, CommonLoaderComponent],
  templateUrl: './descarte-relato.component.html',
  styleUrls: ['./descarte-relato.component.scss'],
})
export class DescarteRelatoComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  @Input() idObra: number | null = null;
  @Input() idRelato: number | null = null;
  @Input() relato: any = null;
  @Input() isLoadingObra: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() relatoDescartado = new EventEmitter<void>();
  sucessoDescarteRelato = false;
  confirmarDescarte = false;
  @Output() loading = new EventEmitter<boolean>();

  constructor(private fichaDaObraService: FichaDaObraService) {}

  ngOnInit() {
    this.sucessoDescarteRelato = false;
    this.confirmarDescarte = true;
  }

  onConfirmarDescarte(confirmar: boolean) {
    this.confirmarDescarte = false;
    if (confirmar) {
      this.loading.emit(true);
      this.descartarRelato();
    } else {
      this.close.emit();
    }
  }

  descartarRelato() {
    this.loading.emit(true);
    if (!this.idObra || !this.idRelato) {
      this.loading.emit(false);
      return;
    }
    this.fichaDaObraService
      .deletarRelatos(this.idObra, this.idRelato)
      .subscribe({
        next: () => {
          this.loading.emit(false);
          this.sucessoDescarteRelato = true;
          this.relatoDescartado.emit();
        },
        error: () => {
          this.loading.emit(false);
        },
      });
  }

  continuar() {
    this.sucessoDescarteRelato = false;
    this.close.emit();
  }
}
